import React from 'react'
import { PropTypes } from 'prop-types'

import { Button } from '@sainsburys-tech/fable'

const SiteButton = ({ onClick, site }) => {
  if (!site) return null

  return (
    <div className="dsib-multiSites__item">
      <Button
        isFullWidth
        variant="secondary"
        onClick={() => onClick(site)}
      >
        {`${site.name} (${site.siteType})`}
      </Button>
    </div>
  )
}

SiteButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  site: PropTypes.shape({
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    siteType: PropTypes.string.isRequired
  }).isRequired,
}

export default SiteButton
